<template>
  <div class="overlay">
    <div class="mini-modal" ref="miniModalRef">
      <div class="mini-modal__header" v-if="title">
        <h2 class="mini-modal__header-title">
          {{ title }}
        </h2>
        <div class="mini-modal__header-line"></div>
        <CloseIcon @click="closeModal(false)"/>
      </div>
      <div class="mini-modal__content">
        <slot/>
      </div>
      <div class="mini-modal__buttons">
        <BaseBtnNew
          :name="firstButtonText"
          @click-btn="$emit('clickSave')"
        >
          <AcceptIcon/>
        </BaseBtnNew>
        <BaseBtnNew
          :name="secondButtonText"
          @click-btn="closeModal(false)"
          red
        >
          <CancelIcon/>
        </BaseBtnNew>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { onClickOutside } from '@vueuse/core'

import BaseBtnNew from '@/components/ui/BaseBtnNew.vue'
import CloseIcon from '@/components/icons/CloseIcon.vue'
import AcceptIcon from '@/components/icons/AcceptIcon.vue'
import CancelIcon from '@/components/icons/CancelIcon.vue'

export default {
  name: 'MiniModal',
  components: {
    BaseBtnNew,
    CloseIcon,
    AcceptIcon,
    CancelIcon
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    firstButtonText: {
      type: String,
      default: 'Подтвердить'
    },
    secondButtonText: {
      type: String,
      default: 'Отменить'
    },
    closeModal: {
      type: Function,
      default: () => {}
    }
  },
  setup (props) {
    const miniModalRef = ref(null)

    onClickOutside( // закрывает модалку при клике на любую другую область
      miniModalRef,
      () => {
        props.closeModal(false)
      }
    )

    return {
      miniModalRef
    }
  }
}
</script>

<style lang="scss" scoped>
.overlay {
  position: absolute;
  inset: 0;
  @include flex-center;
  z-index: 3;
}
.mini-modal {
  background: #FFFFFF;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);
  width: 531px;

  &__header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 24px 24px 0 24px;
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 18px;
    text-align: left;
    color: #000000;

    &-line {
      display: block;
      flex: 1;
      height: 2px;
      background-color: #C8C8C8;
    }
  }

  &__content {
    padding: 24px;
  }

  &__buttons {
    padding: 24px;
    border-top: 2px solid #D6D6D6;
    background-color: #F5F5F5;
    display: flex;
    justify-content: center;
    gap: 30px;
    width: 100%;

    :deep(.base-button) {
      width: 200px;
    }
  }
}
</style>
